import { useQuery } from 'react-query';
import { TeamAPI } from 'api/admin/team';

export default function useTeam(id) {
  return useQuery(['teams', id], () => TeamAPI.getById(id));
}
